import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  TextField,
  TablePagination
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment/moment";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import Heading from "../../../../StyledComponents/Heading/Heading";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});



function GLAccountHistory({ multipleData }) {
  const classes = useStyles();
  const [page, setpage] = useState(0);
  const [RowsPerPage, setRowsPerPage] = useState(20);
  const handleChangePage = (event, newPage) => {
   setpage(newPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
  
    setRowsPerPage(parseInt(event.target.value));
    setpage(0)
  };
  return (
    <div>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          mt={2}
          mb={2}
          style={{ width: "0" }}
        >
          <Heading title="G/L Account History" />
          <TableContainer 
          className="scrollable"
        style={{
          maxHeight: "200px",
          minHeight: "100px",
          overflowY: "auto",
        }}
          >
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
            >
              <TableHead>
                <TableRow sx={{backgroundColor: "#EFF2F4", fontSize: "11" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}>
                    Invoice No
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}>
                    Invoice Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}>
                    Invoice Amount
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}>
                    Submitted BY
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}>
                    Pending with
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {multipleData?.efdv_Invoices?.length > 0 && 
                  multipleData?.efdv_Invoices?.slice(page * RowsPerPage, page * RowsPerPage + RowsPerPage )
                  .map((item, index) => {
                    return (
                      <TableRow key={index} sx={{ fontSize: "10" }}>
                        <TableCell sx={{ p: 1 }}>{item.Invoice_No}</TableCell>
                        <TableCell sx={{ p: 1 }}>{moment(item.Invoice_Date).format("DD-MMM-YYYY")}</TableCell>
                        <TableCell sx={{ p: 1 }}>{item.Invoice_Amount}</TableCell>
                        <TableCell sx={{ p: 1 }}>{item.UserName}</TableCell>
                        <TableCell sx={{ p: 1 }}>{item.PendingWith}</TableCell>

                      </TableRow>
                    );
                  })}
                </TableBody>
              {/* {loading && <TableSkeleton noOfColumns={9} noOfLines={3} />} */}
            </Table>
            {multipleData?.efdv_Invoices?.length === 0 ? <EmptyData /> : ""}
            <TablePagination
            rowsPerPageOptions={[20,40,60]}
            component="div"
            count={multipleData?.efdv_Invoices?.length}
            rowsPerPage={RowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
}

export default GLAccountHistory;
